import { translate } from '@thoughtspot/i18n';
export const ALL_DATA_SOURCES_ID = '_all_worksheets';
export const SPOTTER_DATA_SOURCE_DISCOVERY_ID = 'auto_mode';
export const getAllSourceWorksheetData = () => {
    return {
        id: ALL_DATA_SOURCES_ID,
        name: translate('EUREKA.ALL_SOURCES'),
        aiAnswerGenerationDisabled: true,
        isDeleted: false,
        type: 'ALL_WORKSHEETS',
        isExternal: false,
        description: translate('chooseSourcesEureka.allSources.desc'),
        schema: null,
        tags: [],
    };
};
export const getDataSourceDiscoveryWorksheetData = () => {
    return {
        id: SPOTTER_DATA_SOURCE_DISCOVERY_ID,
        name: translate('Spotter.DataSourceDiscoveryModelLabel'),
        aiAnswerGenerationDisabled: true,
        isDeleted: false,
        description: `<ul>
                <li>${translate('Spotter.DataSourceDiscoveryModel.desc1')}</li>
                <li>${translate('Spotter.DataSourceDiscoveryModel.desc2')}</li>
                <li>${translate('Spotter.DataSourceDiscoveryModel.desc3')}</li>
            </ul>`,
        isExternal: false,
        tags: [],
    };
};
export var ObjectType;
(function (ObjectType) {
    ObjectType["ALL"] = "ALL";
    ObjectType["ANSWER"] = "ANSWER";
    ObjectType["PINBOARD"] = "PINBOARD";
})(ObjectType || (ObjectType = {}));
export var PageContext;
(function (PageContext) {
    PageContext["HOME"] = "HOME_PAGE";
    PageContext["HOME_ANSWER"] = "ANSWERS_LIST";
    PageContext["HOME_LIVEBOARD"] = "PINBOARDS_LIST";
    PageContext["SPOTTER"] = "SPOTTER";
})(PageContext || (PageContext = {}));
export var ResultType;
(function (ResultType) {
    ResultType["searchAnswer"] = "searchAnswer";
    ResultType["searchPinboard"] = "searchPinboard";
    ResultType["searchPinboardViz"] = "searchPinboardViz";
})(ResultType || (ResultType = {}));
export const resultTypeToUrlTermMap = {
    [ResultType.searchPinboard]: 'pinboard',
    [ResultType.searchAnswer]: 'saved-answer',
    [ResultType.searchPinboardViz]: 'pinboard',
};
export const EurekaErrorCodes = {
    NL_INSTRUCTIONS_HYPERLINK_VALIDATION_ERROR_CODE: 2100,
};
export const AI_ANSWER_ERROR = '_EUREKA_AI_ERROR';
//# sourceMappingURL=eureka-common.js.map